import { fromAPIDateString } from 'utils/DateHelper';
import i18nHelper from 'utils/i18nHelper';

/**
 * @@author        j0Shi
 * @@date          2019.09.26
 * @@desc          Outsourced price request functions from object page
 *                 might not work somewhere else !!
 * @@usedby        Object
*/

export default {
  data() {
    return {
      oprhMixin_i18nHelper: i18nHelper(this.$i18n.i18next),
      oprhMixin_forcedHydration: false,
    };
  },
  computed: {
    // start date from the object store
    oprhMixin_objectStoreStartDate() {
      return this.$store.state.objects.priceRequestData.startDate;
    },
    // end date from the object store
    oprhMixin_objectStoreEndDate() {
      return this.$store.state.objects.priceRequestData.endDate;
    },
    // persons from the object store
    oprhMixin_objectStorePersons() {
      return this.$store.state.objects.priceRequestData.persons;
    },
    // identifier key for the price data in the store
    oprhMixin_identifierKey() {
      return this.$store.state.objects.priceRequestData.identifierKey;
    },
  },
  mounted() {
    this.oprhMixin_reset();
  },
  i18nOptions: { namespaces: ['errors'] },
  watch: {
    $route(to, from) {
      this.oprhMixin_reset(to, from);
    },
  },
  methods: {
    // resets store values
    // this is called on every object change (route or mounted)
    oprhMixin_reset(to = false, from = false) {
      // check that route actually changed, because we append params on the page, which also triggers $route, but should not result in a reset
      if (to !== false && from !== false && to.path === from.path) return;

      // reset
      const searchStoreStartDate = this.$router.currentRoute.query.startDate || this.$store.getters.getSearchFilter('startDate') || null;
      const searchStoreEndDate = this.$router.currentRoute.query.endDate || this.$store.getters.getSearchFilter('endDate') || null;
      const searchStorePersons = this.$router.currentRoute.query.persons || this.$store.getters.getSearchFilter('persons') || 2;
      this.$store.commit('SET_OBJECT_PRICE_REQUEST_DATA', {
        startDate: searchStoreStartDate,
        endDate: searchStoreEndDate,
        persons: searchStorePersons,
        language: this.$store.getters.getCurrentLanguage,
      });
      const partner = this.$store.getters.getPartnerConfigValue('partnerID');
      this.$store.commit('SET_OBJECT_PRICE_IDENTIFIER_KEY', { partner });
    },
    // initial price request with get param dates and persons
    oprhMixin_initialPriceRequest() {
      const partner = this.$store.getters.getPartnerConfigValue('partnerID');
      return this.$store.dispatch('GET_OBJECT_PRICE_REQUEST_DATA', {
        startDate: this.$router.currentRoute.query.startDate || this.oprhMixin_objectStoreStartDate || undefined,
        endDate: this.$router.currentRoute.query.endDate || this.oprhMixin_objectStoreEndDate || undefined,
        persons: this.$router.currentRoute.query.persons || this.oprhMixin_objectStorePersons || 2,
        language: this.$store.getters.getCurrentLanguage,
        partner,
      })
        .catch(() => {
        // reset data
          this.$store.commit('SET_APP_HTTPSTATUS', 500);
          this.$store.commit('SET_APP_APIHTTPSTATUS', { type: 'priceRequest', status: 500 });
          this.$store.dispatch('GET_OBJECT_PRICE_REQUEST_DATA', {
            startDate: null,
            endDate: null,
            persons: 2,
            language: this.$store.getters.getCurrentLanguage,
          }).catch(() => {});
          // reset error
          this.$store.commit('SET_FETCHING_PRICE_ERROR', { fetchingPriceError: false });
          // show error
          // sometime lang isn't loaded, wait for it
          this.oprhMixin_i18nHelper.checkKey('errors:object.priceApiInitial.body').then(() => {
          // this is executed on both server/client so we need an additional check for client var
            this.oprhMixin_showErrorToast();
          });
        }).finally(() => {
          this.$store.commit('SET_OBJECT_PICKER_VIEWED_DATE', fromAPIDateString(this.oprhMixin_objectStoreStartDate));
        });
    },
    // shows the error toast in case something went wrong with the price request
    oprhMixin_showErrorToast() {
      if (this.$bvToast) {
        this.$bvToast.toast(this.$t('errors:object.priceApiInitial.body'), {
          title: this.$t('errors:object.priceApiInitial.header'),
          appendToast: true,
          variant: 'warning',
        });
      }
    },
    // forces hydration is userr interacts with stuff that could change prices
    oprhMixin_forceHydrate() {
      // manually hydrate components to avoid hydration errors
      if (this.oprhMixin_forcedHydration) return;
      this.oprhMixin_forcedHydration = true;
      if (typeof this.$refs.objectCosts?.hydrate === 'function') this.$refs.objectCosts.hydrate();
      if (typeof this.$refs.objectPayments?.hydrate === 'function') this.$refs.objectPayments.hydrate();
      if (typeof this.$refs.objectCancelations?.hydrate === 'function') this.$refs.objectCancelations.hydrate();
    },
  },
};
